exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".WahooFlow-728bec65{position:relative}.WahooFlow-728bec65 .instructions-6aca3d6f{text-align:center;max-width:500px;margin:0 auto}.WahooFlow-728bec65 .centeredImg-04767564{text-align:center;margin:20px 0}\n", ""]);

// Exports
exports.locals = {
	"WahooFlow": "WahooFlow-728bec65",
	"instructions": "instructions-6aca3d6f",
	"centeredImg": "centeredImg-04767564"
};